import React, { useState } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';

import { formatDate, formatThaiDateUi } from "../../../../utils/DateUtils";
import { getData, formatCurrency } from '../../../../utils/SamuiUtils';
import { getReport } from '../../../../utils/ReportUtils';

const Main = ({ name, dataMasterList, onPageInsert, onPageUpdate }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [docNo, setDocNo] = useState("");
  const [docType, setDocType] = useState("");
  const [arName, setArName] = useState("");

  const onRowSelected = async (fromData) => {
    if (fromData.Doc_Is_INV_From === 1) {
      const soData = await getData("API_0701_SO_H", `Doc_ID = ${fromData.Ref_DocID} ORDER BY Doc_No DESC`);
      if (soData && soData.length > 0) {
        setFilteredDetailList(soData);
      }
    } else if (fromData.Doc_Is_INV_From === 2) {
      const biData = await getData("API_1301_BL_H", `Doc_ID = ${fromData.Ref_DocID} ORDER BY Doc_No DESC`);
      if (biData && biData.length > 0) {
        setFilteredDetailList(biData);
      }
    } else {
      setFilteredDetailList([]);
    }

    setDocNo(fromData.Doc_No);
    setDocType(fromData.Doc_Is_INV_From === 1 ? "SO" : "BI");
    setArName(fromData.AR_Name);
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState('');

  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const matchesItemSearchTerm =
      data.Doc_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
      data.AR_Name.toLowerCase().includes(searchItemTerm.toLowerCase());

    return matchesItemSearchTerm;
  });

  return <>
    <Breadcrumbs page={name} items={[
      { name: 'งานบัญชี', url: '/account' },
      { name: name, url: '/invoice' },
    ]} />
    <div className="container-fluid card py-3 hidden-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      <div className="row mb-2 align-items-center">
        <div className="col-1">
          <button
            className="btn text-white mx-3"
            onClick={() => onPageInsert()}
            style={{
              backgroundColor: 'rgb(239, 108, 0)',
              whiteSpace: 'nowrap',
              padding: '10px',
              fontSize: '15px'
            }}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> {name}
          </button>
        </div>
        <div className="col-3">
          <div className="input-group">
            <span className="input-group-text">Search</span>
            <input
              type="text"
              className="form-control"
              value={searchItemTerm}
              onChange={(e) => setSearchItemTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="col-8"></div>
      </div>
      <hr />
      <div className="row ">
        <div className="col-5 mb-1" style={{ borderRight: '2px solid #c7c8c9' }}>
          <div className="table-responsive" style={{ maxHeight: '650px', overflowY: 'auto' }}>
            <table id="basic-datatables" className="table table-striped table-hover">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '20%' }}>วันที่</th>
                  <th className="text-center" style={{ width: '15%' }}>เลขเอกสาร</th>
                  <th className="text-center" style={{ width: '42%' }}>ชื่อลูกค้า</th>
                  <th className="text-center" style={{ width: '18%' }}>สร้างจาก</th>
                  <th className="text-center" style={{ width: '5%' }}>
                    <i className="fa fa-edit" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredItemData.length > 0 ? (
                  filteredItemData.map((data, index) => (
                    <tr
                      key={data.Doc_Id || index + 1}
                      onClick={() => onRowSelected(data)}
                      style={{
                        cursor: "pointer",
                        backgroundColor:
                          data.Doc_No === docNo
                            ? "rgb(105, 188, 216)"
                            : "transparent",
                        transition: "background-color 0.3s ease",
                      }}>
                      <td className="text-center">{formatThaiDateUi(data.Doc_Date)}</td>
                      <td className="text-center">{data.Doc_No}</td>
                      <td className="text-left">{data.AR_Name || '-'}</td>
                      <td className="text-center">
                        <button
                          className="btn"
                          style={{
                            backgroundColor: data.Doc_Is_INV_From === 1 ? 'red' : 'orange',
                            color: 'white',
                            width: '100%'
                          }}
                        >
                          {data.Doc_Is_INV_From === 1 ? 'ใบขาย' : 'ใบวางบิล'}
                        </button>
                      </td>
                      <td className="text-center">
                        <button className="btn btn-sm" onClick={() => onPageUpdate(data.Doc_No)}>
                          <i className="fa fa-edit" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col-7 mb-3">
          {filteredDetailList.length !== 0 && (
            <div className="justify-content-between align-items-center mb-3">
              <div className="row">
                <div className="col-12">
                  <p className="card-title mb-0">
                    เอกสารเลขที่: {docNo} {arName}
                  </p>
                </div>
                <div className="col-12 d-flex justify-content-end">
                  <button
                    className="btn d-flex align-items-center text-white me-2"
                    style={{
                      backgroundColor: 'rgb(239, 108, 0)',
                      fontSize: '16px',
                    }}
                    onClick={() => getReport("inv1", docNo)}
                  >
                    <i className="fa fa-print me-2" aria-hidden="true"></i>
                    พิมพ์ใบกำกับภาษี (ต้นฉบับ)
                  </button>
                  <button
                    className="btn d-flex align-items-center text-white"
                    style={{
                      backgroundColor: 'rgb(239, 108, 0)',
                      fontSize: '16px',
                    }}
                    onClick={() => getReport("inv2", docNo)}
                  >
                    <i className="fa fa-print me-2" aria-hidden="true"></i>
                    พิมพ์ใบกำกับภาษี (สำเนา)
                  </button>
                </div>
              </div>
            </div>
          )}
          <div
            className="table-responsive"
            style={{
              maxHeight: '600px',
              overflowY: 'auto',
            }}
          >
            <table id="basic-datatables" className="table table-striped table-hover" style={{ minWidth: '100%' }}>
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '3%' }}>ลำดับ</th>
                  <th className="text-center" style={{ width: '14%' }}>เลขที่{docType === 'SO' ? 'ใบขาย' : 'ใบวางบิล'}</th>
                  <th className="text-center" style={{ width: '10%' }}>วันที่เอกสาร</th>
                  <th className="text-center" style={{ width: '40%' }}>ชื่อลูกค้า</th>
                  <th className="text-center" style={{ width: '20%' }}>รวมราคา</th>
                  <th className="text-center" style={{ width: '22%' }}>สถานะ{docType === 'SO' ? 'ใบขาย' : 'ใบวางบิล'}</th>
                </tr>
              </thead>
              <tbody>
                {filteredDetailList.length > 0 ? (
                  filteredDetailList.map((item, index) => (
                    <tr key={item.DT_Id || index + 1}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{item.Doc_No}</td>
                      <td className="text-center">{formatDate(item.Doc_Date)}</td>
                      <td className="text-left">{item.AR_Name}</td>
                      <td className="text-end">{docType === 'SO' ? formatCurrency(item.NetTotal) : formatCurrency(item.BL_Net_Total)}</td>
                      <td className="text-center">
                        <button
                          className="btn"
                          style={{
                            backgroundColor: docType === 'SO' ? item.DocStatusPaid_Colour : item.DocBLStatusPaid_Colour,
                            color: 'white',
                            width: '100%'
                          }}
                        >
                          {docType === 'SO' ? item.DocStatusPaid_Name : item.DocBLStatusPaid_Name}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <center>
                        <h5>ไม่พบข้อมูล</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </>;
};

export default Main;